import { Box } from "@mui/material";

import { Nodata } from "../../utils/common/Nodata";

const ChatbotList = () => {
  return (
    <Box className="table">
      <Nodata type="Chatbot" />
    </Box>
  );
};

export default ChatbotList;
